/**
 * Copyright IBM Corp. 2020, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import React from 'react';
import { DataTable } from 'carbon-components-react';
var TableHead = DataTable.TableHead;

var DatagridHead = function DatagridHead(datagridState) {
  var _datagridState$header = datagridState.headerGroups,
      headerGroups = _datagridState$header === void 0 ? [] : _datagridState$header,
      headRef = datagridState.headRef,
      HeaderRow = datagridState.HeaderRow;
  return /*#__PURE__*/React.createElement(TableHead, null, headerGroups.map(function (headerGroup) {
    return (// doesn't support header grouping.
      HeaderRow(datagridState, headRef, headerGroup)
    );
  }));
};

export default DatagridHead;